import { Lock, Unlock } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface AdminEditToggleProps {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  disabled?: boolean;
}

/**
 * Atom: Toggle switch for admin edit mode on locked requests
 * Shows lock/unlock icon and allows admins to enable editing on normally locked states
 */
export function AdminEditToggle({ enabled, onToggle, disabled = false }: AdminEditToggleProps) {
  return (
    <div className="flex items-center gap-2">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 dark:border-amber-800 dark:bg-amber-950/20">
              {enabled ? (
                <Unlock className="size-4 text-amber-600 dark:text-amber-500" />
              ) : (
                <Lock className="size-4 text-amber-600 dark:text-amber-500" />
              )}
              <Label
                htmlFor="admin-edit-mode"
                className="cursor-pointer text-sm font-medium text-amber-900 dark:text-amber-100"
              >
                Modo Edición (Admin)
              </Label>
              <Switch
                id="admin-edit-mode"
                checked={enabled}
                onCheckedChange={onToggle}
                disabled={disabled}
                className="data-[state=checked]:bg-amber-600"
              />
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p className="max-w-xs text-sm">
              {enabled
                ? "Modo de edición activado. Puede modificar ministros, notas y código."
                : "Active el modo de edición para modificar esta solicitud aprobada."}
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
